import { render, staticRenderFns } from "./DialogModal.vue?vue&type=template&id=2358b098&scoped=true&"
import script from "./DialogModal.vue?vue&type=script&lang=js&"
export * from "./DialogModal.vue?vue&type=script&lang=js&"
import style0 from "./DialogModal.vue?vue&type=style&index=0&id=2358b098&lang=postcss&scoped=true&"
import style1 from "./DialogModal.vue?vue&type=style&index=1&id=2358b098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2358b098",
  null
  
)

export default component.exports